import styled from "styled-components"

const TimelineAxisTick = styled.div`
  border-radius: 10px;
  border: 2px solid ${props => props.theme.color.area};
  background-color: transparent;
  box-sizing: content-box;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -7px;
  margin-top: -7px;
  width: 10px;
  height: 10px;
`

export default TimelineAxisTick
